"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionTab = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const OrderedListMenu_style_1 = require("../OrderedListMenu.style");
const ui_common_components_1 = require("@desygner/ui-common-components");
const OrderedListContext_1 = require("../OrderedListContext");
function SelectionTab() {
    const { labels, orderedRegex, setOrderedRegex, regexButtons } = (0, react_1.useContext)(OrderedListContext_1.OrderedListContext);
    return ((0, jsx_runtime_1.jsxs)(OrderedListMenu_style_1.StyledSelectionTabContainer, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'Body', children: labels.separator }), (0, jsx_runtime_1.jsx)(OrderedListMenu_style_1.StyledButtonsContainer, { children: regexButtons.map(({ label, regex }, index) => ((0, jsx_runtime_1.jsx)(OrderedListMenu_style_1.StyledRegexButton, { isSelected: orderedRegex === regex, onClick: () => setOrderedRegex(regex), children: label }, index))) })] }));
}
exports.SelectionTab = SelectionTab;
//# sourceMappingURL=SelectionTab.js.map